export default {
  INVESTOR_PROFILE_ON_EMERGENCY_FUND_REPOSITORY: Symbol.for('INVESTOR_PROFILE_ON_EMERGENCY_FUND_REPOSITORY'),
  UPDATE_INVESTOR_PROFILE_ON_EMERGENCY_FUND_COMMAND: Symbol.for('UPDATE_INVESTOR_PROFILE_ON_EMERGENCY_FUND_COMMAND'),
};
